module.exports = __webpack_public_path__ + "h5/img/kefu.eef94fbb.png";